module.exports = __webpack_public_path__ + "img/英文版_库尔_天津.34505a1d.webp";